import common from './colors.common';
import retro from './colors.retro';
import modern from './colors.modern';

let oldTheme = {};

oldTheme.colors = {
  common,
  retro,
  modern,
};

export default oldTheme;
